import React, { useState } from 'react';
import './deleteprompt.css';

/** A Prompt with confirm/cancel buttons for deleting an item.
 * @param {Object} props - The properties passed to the DeletePrompt component.
 * @param {props.id} id - The ID of the item to be deleted.
 * @param {props.onDelete} onDelete - Callback function to be called when the delete action is confirmed. 
 * @returns {JSX.Element} The rendered DeletePrompt component.
 */
const DeletePrompt = ({ id, onDelete }) => {
    const [collapsed, setCollapsed] = useState( true );
    
    function handleDeleteClick(e){
        setCollapsed( false );
    }
    
    function handleCancel(){
        setCollapsed( true );
    }

    return ( 
        <div className='delete-prompt-container'>
            { collapsed ?            
            (<div className='delete-btn-container'>
                <button onClick={handleDeleteClick}>Delete</button>
                {/* <img className='delete-btn' src={DeleteBtn} onClick={handleDeleteClick} /> */}
            </div>) :            
            (<div className={'prompt-container'}>
                <h4>Are you sure you want to delete this?</h4>
                <button onClick={onDelete} style={{backgroundColor:'Red', color: 'White' }}>Confirm</button>
                <button onClick={handleCancel} style={{backgroundColor:'Green', color: 'White' }}>Cancel</button>
            </div>)
            }
        </div> 
    );
}

export default DeletePrompt